import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { Product } from "@aurelia/types";
import { toast } from "@aurelia/ui";
import { apiFetch, ApiError } from "../../lib/api-client";
import { useAuthStore } from "../../lib/stores/auth";

export function useWishlist() {
  const isAuthenticated = useAuthStore((s) => s.status === "authenticated");
  return useQuery({
    queryKey: ["wishlist"],
    queryFn: () => apiFetch<{ products: Product[] }>("/wishlist").then((r) => r.products),
    enabled: isAuthenticated
  });
}

export function useToggleWishlist() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (productId: string) =>
      apiFetch<{ wishlisted: boolean }>("/wishlist/toggle", {
        method: "POST",
        body: JSON.stringify({ productId })
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["wishlist"] }),
    // Anonymous visitors hit this before the button is ever disabled (the
    // toggle is available on every product card, signed in or not), so a
    // 401 here is an expected, common case — not a real error to swallow
    // silently like the request failing would be.
    onError: (error: unknown) => {
      if (error instanceof ApiError && error.status === 401) {
        toast("Sign in to save items to your wishlist", "danger");
      }
    }
  });
}
